import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, Image, TextInput } from '../../../types'

@Injectable({ providedIn: 'root' })
export class LocationsMapLocationConverter extends CmsConverterService<LocationsMapLocationData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_title_text?.value
    const altText = formData.st_alt_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      image: CmsConverterService.mapImage(formData?.st_image, lazyLoad, altText, title),
      position: {
        mapLeft: formData.st_position_map_left?.value ?? '0%',
        mapTop: formData.st_position_map_top?.value ?? '0%',
        mapLeftMobile: formData.st_position_map_mobile_left?.value ?? '0%',
        mapTopMobile: formData.st_position_map_mobile_top?.value ?? '0%',
        regionLeft: formData.st_position_region_left?.value ?? '0%',
        regionTop: formData.st_position_region_top?.value ?? '0%',
        regionLeftMobile: formData.st_position_region_mobile_left?.value ?? '0%',
        regionTopMobile: formData.st_position_region_mobile_top?.value ?? '0%'
      },
      types: formData.st_type?.value?.map((value: any) => value?.identifier ?? '') ?? [],
      text: formData.st_text ?? defaultTextInput,
      identifier: formData.st_identifier?.value ?? '',
      iconCloseColor: formData?.st_color?.value?.identifier ?? 'white'
    }
  }
}

export const LOCATIONS_MAP_LOCATION_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, LocationsMapLocationData>>(
  'LocationsMapLocationConverter')

export interface LocationsMapLocationData extends ConvertedComponentData {
  image: Image;
  position: Position;
  types: string[];
  text: TextInput;
  identifier: string;
  iconCloseColor: string;
}

export interface Position {
  mapLeft: string;
  mapTop: string;
  mapLeftMobile: string;
  mapTopMobile: string;
  regionLeft: string;
  regionTop: string;
  regionLeftMobile: string;
  regionTopMobile: string;
}
